import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dropdown } from 'components/common'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { InputOptions } from 'types/input'
import { fetchAggregators } from 'utils/api/aggregatorApi'
import { generateInvalidOnlinePricing } from 'utils/api/pricingApi'
import { fetchStores } from 'utils/api/storeApi'
import { storeAggregatorSchema } from 'utils/schema/storeAggregatorSchema'
import toast from 'react-hot-toast'

interface AggregatorType {
  _id: string
  aggregatorName: string
}

const generateInvalidOnlinePriceReport = () => {
  const [options, setOptions] = useState<InputOptions[]>([
    { label: 'Aggregators', value: null, disabled: false },
  ])

  const [storeOptions, setStoreOptions] = useState<InputOptions[]>([
    { label: 'Stores', value: null, disabled: false },
  ])

  const {
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(storeAggregatorSchema),
  })

  const handleGenerateReport = async (data: any) => {
    await generateInvalidOnlinePricing({ filters: data })
    toast.success(`Report will be sent via email`, {
      duration: 3000,
    })
  }

  const fetchAggregatorAndStore = async () => {
    const { data: aggregators } = await fetchAggregators({
      limit: 600,
      page: 1,
    })

    if (aggregators?.docs && aggregators.docs.length > 0) {
      setOptions(
        aggregators.docs
          .map((aggregator: AggregatorType) => {
            return { label: aggregator.aggregatorName, value: aggregator._id }
          })
          .sort((a: any, b: any) => a.value.localeCompare(b.value)),
      )
    }

    const { data: stores } = await fetchStores({
      limit: 600,
      page: 1,
      isThirdPartyStore: false,
    })

    if (stores?.docs && stores.docs.length > 0) {
      setStoreOptions(
        stores.docs
          .map((stores: { storeName: string; _id: string }) => ({
            label: stores.storeName,
            value: stores._id,
          }))
          .sort((a: any, b: any) => a.value.localeCompare(b.value)),
      )
    }
  }

  useEffect(() => {
    fetchAggregatorAndStore()
  }, [])

  return (
    <div className="mb-10 w-full max-w-[650px] items-center">
      <form onSubmit={handleSubmit(handleGenerateReport)}>
        <h3 className="title">Generate Invalid Online Price Report</h3>
        <div className="flex gap-3">
          <Dropdown
            label="Aggregator"
            options={options}
            name={'aggregatorId'}
            setValue={setValue}
            defaultValue={false}
            error={errors?.aggregatorId?.message as string}
          />
          <Dropdown
            label="Store"
            options={storeOptions}
            name={'storeId'}
            setValue={setValue}
            defaultValue={false}
            error={errors?.storeId?.message as string}
          />
          <Button
            className="mt-6 h-10"
            type="submit"
            variant="outline"
            buttonText="Generate"
          />
        </div>
      </form>
    </div>
  )
}

export default generateInvalidOnlinePriceReport
